<template>
  <div>
    <base-header type="gradient-info" class="pb-6 pb-8 pt-5 pt-md-8">
      <div class="row mb-2">
        <div class="col-12 col-md-6">
          <h1 class="text-white pt-3 px-3">หน้าจัดการสมาชิก</h1>
          <p
            class="text-white pb-3 px-3"
            v-if="isShippop()"
          >เพิ่ม แก้ไข ลบสมาชิก SHIPPOP</p>
          <p
            class="text-white pb-3 px-3"
            v-else
          >เพิ่ม แก้ไข ลบสมาชิก และแสดงตารางรายละเอียดสมาชิกทั้งหมดที่มีอยู่ภายในสาขา</p>
        </div>
        <div class="col-12 col-md-12 col-lg-5 align-self-center px-3 text-right">
          <h1 class="display-3 text-white">
            <div v-if="limited == 0">
               <small>จำนวนผู้ใช้ :</small> {{members.length}} / ไม่จำกัด <small>คน</small>
            </div>
            <div v-else>
              <small>จำนวนผู้ใช้ :</small> {{members.length}} / {{limited}} <small>คน</small>
            </div>
          </h1>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7 mb-5">
      <div class="row mb-3">
        <div class="col-12">
          <div class="card shadow">
            <div class="card-body bg-transparent">
              <div class="row justify-content-between">
                <div class="col-12">
                  <h3 class="text-muted">เพิ่มสมาชิก</h3>

                  <form v-on:submit.prevent="addUser()">
                    <div class="row">
                      <div class="col-12 col-md-6 col-lg mb-3">
                        <input
                          v-model="inputAdd.name"
                          class="form-control"
                          placeholder="ชื่อ-นามสกุล"
                          :class="{ 'is-invalid': submitted && $v.inputAdd.name.$error }"
                        />
                        <div
                          v-if="submitted && !$v.inputAdd.name.required"
                          class="invalid-feedback"
                        >กรุณากรอกชื่อ-นามสกุล</div>
                        <div
                          class="error invalid-feedback"
                          v-if="!$v.inputAdd.name.minLength"
                        >กรุณากรอก"ชื่อ-นามสกุล"อย่างน้อย {{$v.inputAdd.name.$params.minLength.min}} ตัวอักษร</div>
                      </div>
                      <div class="col-12 col-md-6 col-lg mb-3">
                        <input
                          v-model="inputAdd.email"
                          class="form-control"
                          placeholder="อีเมล์"
                          :class="{ 'is-invalid': submitted && $v.inputAdd.email.$error }"
                        />
                        <div v-if="submitted && $v.inputAdd.email.$error" class="invalid-feedback">
                          <span v-if="!$v.inputAdd.email.required">กรุณากรอกอีเมล์</span>
                          <span v-if="!$v.inputAdd.email.email">รูปแบบอีเมล์ไม่ถูกต้อง</span>
                        </div>
                      </div>
                      <div class="col-12 col-md-6 col-lg mb-3">
                        <input
                          type="password"
                          v-model="inputAdd.password"
                          placeholder="รหัสผ่าน"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.inputAdd.password.$error }"
                        />
                        <div
                          v-if="submitted && $v.inputAdd.password.$error"
                          class="invalid-feedback"
                        >
                          <span v-if="!$v.inputAdd.password.required">กรุณากรอกรหัสผ่าน</span>
                          <span
                            v-if="!$v.inputAdd.password.minLength"
                          >กรุณากรอก"รหัสผ่าน"อย่างน้อย {{$v.inputAdd.password.$params.minLength.min}} ตัวอักษร</span>
                        </div>
                      </div>
                      <div class="col-12 col-md-6 col-lg mb-3">
                        <b-form-select
                          v-model="inputAdd.role"
                          :options="options"
                          :class="{ 'is-invalid': submitted && $v.inputAdd.role.$error }"
                        ></b-form-select>
                        <div
                          v-if="submitted && !$v.inputAdd.role.required"
                          class="invalid-feedback"
                        >กรุณาเลือกสถานะ</div>
                      </div>
                      <div class="col-lg-2">
                        <button type="submit" class="btn btn-info btn-block btn-icon">เพิ่มสมาชิก</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row ป">
        <div class="col">
          <div class="card shadow">
            <div class="card-header bg-transparent">
              <div class="row justify-content-between">
                <div class="col-12 col-md d-flex align-items-center">
                  <h3 class="text-muted mb-0">ตารางแสดงสมาชิก</h3>
                </div>
                <div class="col-12 col-md-4">
                  <b-form-input v-model="filter" placeholder="ค้นหาข้อมูล"></b-form-input>
                </div>
              </div>
            </div>
            <div>
              <div class="table-responsive scroll-bar-pop">
                <b-table
                  show-empty
                  stacked="md"
                  :items="members"
                  :fields="fields"
                  :filter="filter"
                  @filtered="onFiltered"
                  :busy="busy"
                >
                  <div slot="table-busy" class="text-center">
                    <BlockUI>
                      <div class="loader"></div>
                    </BlockUI>
                  </div>
                  <template slot="index" slot-scope="data">{{ data.index + 1 }}</template>

                  <template slot="name" slot-scope="row">
                    <input
                      type="text"
                      class="form-control"
                      v-model="inputEdit.name"
                      v-if="inputEdit.edit == row.item.id"
                      :class="{ 'is-invalid': submittEdit && $v.inputEdit.name.$error }"
                    />
                    <div v-else>{{row.item.name}}</div>
                    <!-- vuelidate -->
                    <label
                      v-if="submittEdit && !$v.inputEdit.name.required"
                      class="invalid-feedback"
                    >กรุณากรอกชื่อ</label>
                    <label
                      class="error invalid-feedback"
                      v-if="!$v.inputEdit.name.minLength"
                    >กรุณากรอก"ชื่อ-สกุล"อย่างน้อย {{$v.inputEdit.name.$params.minLength.min}} ตัวอักษร</label>
                  </template>

                  <template slot="email" slot-scope="row">
                    <input
                      type="text"
                      class="form-control"
                      v-if="inputEdit.edit == row.item.id"
                      v-model="inputEdit.email"
                      :class="{ 'is-invalid': submittEdit && $v.inputEdit.email.$error }"
                    />
                    <div v-else>{{row.item.email}}</div>
                    <!-- vuelidate -->
                    <div v-if="submittEdit && $v.inputEdit.email.$error" class="invalid-feedback">
                      <span v-if="!$v.inputEdit.email.required">กรุณากรอกอีเมล์</span>
                      <span v-if="!$v.inputEdit.email.email">รูปแบบอีเมล์ไม่ถูกต้อง</span>
                    </div>
                  </template>

                   <template slot="pass" slot-scope="row">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="รหัสผ่าน"
                      v-if="inputEdit.edit == row.item.id"
                      v-model="inputEdit.password"
                      :class="{ 'is-invalid': submittEdit && $v.inputEdit.password.$error }"
                    />
                    <div v-else>#</div>
                    <!-- vuelidate -->
                    <div v-if="submittEdit && $v.inputEdit.password.$error" class="invalid-feedback">
                     <span v-if="!$v.inputEdit.password.minLength">กรุณากรอก"รหัสผ่าน"อย่างน้อย {{$v.inputEdit.password.$params.minLength.min}} ตัวอักษร</span>
                    </div>
                  </template>

                  <template slot="role" slot-scope="row">
                    <b-form-select
                      v-model="inputEdit.role"
                      :options="options"
                      v-if="inputEdit.edit == row.item.id"
                      :class="{ 'is-invalid': submittEdit && $v.inputEdit.role.$error }"
                    ></b-form-select>
                    <div v-else>{{ row.item.role | formatRole }}</div>
                    <!-- vuelidate -->
                    <div
                      v-if="submittEdit && !$v.inputEdit.role.required"
                      class="invalid-feedback"
                    >กรุณาเลือกสถานะ</div>
                  </template>

                  <template slot="manage" slot-scope="row">
                    <button
                      class="btn px-3 btn-sm btn-info"
                      v-on:click="(
                                inputEdit.edit  = row.item.id,
                                inputEdit.name  = row.item.name,
                                inputEdit.email = row.item.email,
                                inputEdit.role  = row.item.role

                              )"
                      v-if="inputEdit.edit !== row.item.id"
                    >แก้ไข</button>

                    <button
                      class="btn px-3 btn-sm btn-success"
                      v-on:click="updateUser(row.item.id)"
                      v-if="inputEdit.edit == row.item.id"
                    >อัพเดท</button>
                    <button
                      class="btn px-3 btn-sm btn-secondary"
                      v-on:click="inputEdit.edit = false"
                      v-if="inputEdit.edit == row.item.id"
                    >ยกเลิก</button>

                    <button
                      class="btn px-3 btn-sm btn-danger"
                      @click="(showComfirmModal(), modal.idDel = row.item.id)"
                      :disabled="row.item.role == 'admin' && countAdmin < 2"
                    >ลบ</button>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const API_URL = process.env.VUE_APP_API;
import validatePop from "../plugins/validatePop.js"
import { required, email, minLength, sameAs } from "vuelidate/lib/validators"
export default {
  name: "UserManage",
  data() {
    return {
      members: [],
      limited:"",
      number:"",
      submitted: false,
      submittEdit: false,
      showModalError: false,
      filter: null,
      busy: true,
      msg: "กรุณารอสักครู่",
      inputAdd: {
        name: "",
        email: "",
        password: "",
        role: null
      },

      inputEdit: {
        edit: "",
        name: "",
        password: "",
        email: "",
        role: null
      },
      errorSys: {
        apiErrGetUserManage: "พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #001",
        apiErrDelUserManage: "พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #002",
        apiErrAddUserManage: "พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #003",
        apiErrUpdateUserManage: "พบปัญหาในการเชื่อมต่อ กรุณาติดต่อเจ้าหน้าที่ #004",

      },

      modal: {
        idDel: "",
        msgBody: "success"
      },
      fields: [
        { key: "index", label: "#", sortable: true },
        { key: "name", label: "ชื่อสกุล", sortable: true },
        { key: "email", label: "ไอดีสมาชิก", sortable: true },
        { key: "pass", label: "รหัสผ่าน", sortable: true },
        { key: "role", label: "ระดับ", sortable: true },
        { key: "manage", label: "การจัดการ", sortable: false }
      ],
      // options: [
      //   { value: null, text: "กรุณาเลือกสถานะ", disabled: true },
      //   { value: "admin", text: "หัวหน้า" },
      //   { value: "member", text: "พนักงาน" }
      // ]
    };
  },
  filters: {
      formatRole( str ) {
          let role = ''
          if( str == 'member'){
            role = 'admin'
          }else if( str == 'admin' ){
            role = 'member'
          }else if( str == 'superadmin'){
            role = 'ตัวแทนจำหน่าย'
        }else if ( str == 'shippop' ){
            role = 'พนักงาน SHIPPOP'
          }else{
            role = str
          }
          return role
      }
    },
  validations: {
    inputAdd: {
      name: { required, minLength: minLength(4) },
      email: { required, email },
      password: { required, minLength: minLength(6) },
      role: { required }
    },
    inputEdit: {
      name: { required, minLength: minLength(4) },
      email: { required, email },
      password: { minLength: minLength(6) },
      role: { required }
    }
  },
  computed:{
    options(){
      let role = [
        { value: null, text: "กรุณาเลือกสถานะ", disabled: true },
        { value: "admin", text: "admin" },
        { value: "member", text: "member" }
      ]
      if( this.isShippop() ){
        role = [
          { value: null, text: "กรุณาเลือกสถานะ", disabled: true },
          { value: "shippop", text: "พนักงาน SHIPPOP" }
        ]
      }
      return role
    },
    countAdmin(){
      try {
        const result = this.members.reduce((sum,mem) => {
          let i = 0
          if( mem.role == 'admin' ){
            i = 1 
          }
          return sum+i
        }, 0)

        return result
      }
      catch(err) {
        return 0
      }
    }
  },
  methods: {
    deleteUser() {
      let id = this.modal.idDel;
      this.busy = true
      this.$http
        .delete(API_URL + "/shop/member/" + id, {
          headers: {
            Token: localStorage.getItem("access_token")
          }
        })
        .then(res => {
          let checkError = validatePop( res )
            if( !checkError.status ){
              this.showErrorModal( checkError.msg )
              this.busy = false
              return false
            }
          this.busy = false
          this.showSuccessModal("ลบข้อมูลสำเร็จ")
          this.getUser();
        })
        .catch(error => {
          this.showErrorModal( apiErrDelUserManage )
        });
    },
    addUser(e) {
      this.submitted = true;
      this.$v.inputAdd.$touch();
      if (this.$v.inputAdd.$invalid) {
        return false
      }

      this.$http
        .post(
          API_URL + "/shop/member",
          {
            name: this.inputAdd.name,
            email: this.inputAdd.email,
            password: this.inputAdd.password,
            role: this.inputAdd.role
          },
          {
            headers: { Token: localStorage.getItem("access_token") }
          }
        )
        .then(res => {
          let checkError = validatePop( res )
            if( !checkError.status ){
              this.showErrorModal( checkError.msg )
              return false
            }
          this.showSuccessModal("เพิ่มข้อมูลเรียบร้อยค่ะ")
          this.getUser();
          this.submitted = false;
          this.inputAdd.name = "";
          this.inputAdd.email = "";
          this.inputAdd.password = "";
          this.inputAdd.role = "";
        })
        .catch(error => {
          this.showErrorModal(this.errorSys.apiErrAddUserManage)
        })
    },
    getUser() {
      this.$http
        .get(API_URL + "/shop/members", {
          headers: {
            Token: localStorage.getItem("access_token")
          }
        })
        .then(res => {
          let checkError = validatePop( res )
            if( !checkError.status ){
              if( checkError.notices == "token is expired"){
                this.$router.push("/logout")
              }
              this.busy = false
              this.showErrorModal( checkError.msg )
              return false
            }
          this.members = res.data.data[0]
          this.limited = res.data.data.limited_member ? res.data.data.limited_member : 0
          this.busy = false
        })
        .catch(error => {
          this.busy = false
          this.showErrorModal( this.errorSys.apiErrGetUserManage )
        })
    },
    updateUser(id, pass) {
      this.submittEdit = true;
      this.$v.inputEdit.$touch();
      if (this.$v.inputEdit.$invalid) {
        return false
      }
      this.$http
        .put(
          API_URL + "/shop/member/" + id,
          {
            name: this.inputEdit.name,
            email: this.inputEdit.email,
            password: this.inputEdit.password != "" ? this.inputEdit.password : "",
            role: this.inputEdit.role
          },
          {
            headers: { Token: localStorage.getItem("access_token") }
          }
        )
        .then(res => {
          let checkError = validatePop( res )
            if( !checkError.status ){
              this.busy = false
              this.showErrorModal( checkError.msg )
              return false
            }
          this.showSuccessModal("แก้ไขสมาชิกเสร็จสิ้น");
          this.getUser();
          this.inputEdit.edit = false;
          this.submittEdit = false;
        })
        .catch(error => {
          this.showErrorModal( this.errorSys.apiErrUpdateUserManage )
        })
    },
    showComfirmModal() {
      this.$bvModal
        .msgBoxConfirm(`คุณต้องการจะลบข้อมูลสมาชิก `, {
          title: "กรุณายืนยัน",
          size: "sm",
          buttonSize: "sm",
          okVariant: "danger",
          okTitle: "ยืนยัน",
          cancelTitle: "ยกเลิก",
          //for P' OOOO
          contentClass: "modal-confirm",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) {
            this.deleteUser();
          }
        })
    },
    showSuccessModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "SUCCESS",
        size: "sm",
        buttonSize: "sm",
        okVariant: "success",
        okTitle: "ตกลง",
        contentClass: "modal-success",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      });
    },
    showErrorModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "ERROR",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "ลองอีกครั้ง",
        contentClass: "modal-errors",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true
      });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
    },
    isShippop(){
      let user = JSON.parse(localStorage.getItem('user'))
      return user.role == 'shippop'
    },
  },
  mounted() {
    this.getUser();
  }
};
</script>
